import { render, staticRenderFns } from "./approve_buttons.vue?vue&type=template&id=be0690c0&"
import script from "./approve_buttons.vue?vue&type=script&lang=js&"
export * from "./approve_buttons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports